import type { Task } from '~/types/models';

export function useTaskQuickCreate() {
    const isOpen = useState<boolean>('task-quick-create-open', () => false);
    const initialDraft = useState<Partial<Task> | null>('task-quick-create-draft', () => null);

    function openTaskQuickCreate(draft: Partial<Task> = {}) {
        initialDraft.value = { ...draft };
        isOpen.value = true;
    }

    function closeTaskQuickCreate() {
        isOpen.value = false;
        initialDraft.value = null;
    }

    return {
        isOpen,
        initialDraft,
        openTaskQuickCreate,
        closeTaskQuickCreate,
    };
}
